// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"47a94970","977":"d3941b75"}[chunkId] + ".chunk.js";
};